module.exports = __webpack_public_path__ + "static/Заявление_о_размещении_вклада-b5eed90e74d6dbeec6b13aacd3d3a10f.pdf";